
import { PJAxios, usePJStore } from '@jaf/jaf-react-core';
import moment from 'moment';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { DataView } from 'primereact/dataview';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Editor } from 'primereact/editor';
import React, { useEffect, useState } from 'react';
import { flushCache } from '../../api/ChatbotApi';
import './GestioneEventi.css';




function GestioneEventi(props) {

  const { storage } = usePJStore((state) => state.storage)

  const today = new Date()
  const startOfWeek = new Date(today.setDate(today.getDate() - today.getDay() + 1)); // Luned� della settimana corrente
  const endOfWeek = new Date(today.setDate(today.getDate() - today.getDay() + 7)); // Domenica della settimana corrente

  const [eventi, setEventi] = useState(null);
  const [editEvento, setEditEvento] = useState(null);
  const [removeEvento, setRemoveEvento] = useState(null);
  const [createEvento, setCreateEvento] = useState(null);

  const [tipoEvento, setTipoEvento] = useState(null);
  const [dataInfo, setDataInfo] = useState(null);
  const [dataInizio, setDataInizio] = useState(null);
  const [dataFine, setDataFine] = useState(null);
  const [mese, setMese] = useState(null);
  const [giorno, setGiorno] = useState(null);
  const [wd, setWd] = useState(null);
  const [periodicita, setPeriodicita] = useState(null);
  const [idConfigTemp, setIdConfigTemp] = useState(null);
  const [idEventTemp, setIdEventTemp] = useState(null);
  const [idConfigTempEdit, setIdConfigTempEdit] = useState(null);
  const [idEventTempEdit, setIdEventTempEdit] = useState(null);
  const [idConfigTempCreate, setIdConfigTempCreate] = useState(null);
  const [idEventTempCreate, setIdEventTempCreate] = useState(null);
  const [funzioneHTML, setFunzioneHTML] = useState(null);
  const [correlati, setCorrelati] = useState(null)

  const [bundleIt, setBundleIt] = useState(null);
  const [bundleEn, setBundleEn] = useState(null);

  const [bundleEvento, setBundleEvento] = useState(null);

  const [tematicheCollegate, setTematicheCollegate] = useState([])
  const [selectedTematicheCollegate, setSelectedTematicheCollegate] = useState([])


  const [createEventoVisible, setCreateEventoVisible] = useState(false);
  const [modificaEventoVisible, setModificaEventoVisible] = useState(false);
  const [filteredEvents, setFilteredEvents] = useState([]);

  const getText = usePJStore((state) => state.i18n_getText)
  const bundles = usePJStore((state) => state.i18n_bundles)

const getTextByLang = (lang, key) => {
  return bundles?.[lang]?.[key]
}

  const dbTest = usePJStore((state) => state.appInfo_dbTest);
 

  /*const rowTemp = {

    idConfigRowTemp: "",
    idEventRowTemp: ""
  }*/

  const tipoEventoOptions = [
    { name: 'LBL_EVENTO_PUNTUALE', code: 'n' },
    { name: 'LBL_EVENTO_SETTIMANALE', code: 'S' }
    //{ name: 'LBL_EVENTO_RIPETUTO', code: 'y' }
  ];

  const meseOptions = [
    { name: 'LBL_MONTH:1', code: '0' },
    { name: 'LBL_MONTH:2', code: '1' },
    { name: 'LBL_MONTH:3', code: '2' },
    { name: 'LBL_MONTH:4', code: '3' },
    { name: 'LBL_MONTH:5', code: '4' },
    { name: 'LBL_MONTH:6', code: '5' },
    { name: 'LBL_MONTH:7', code: '6' },
    { name: 'LBL_MONTH:8', code: '7' },
    { name: 'LBL_MONTH:9', code: '8' },
    { name: 'LBL_MONTH:10', code: '9' },
    { name: 'LBL_MONTH:11', code: '10' },
    { name: 'LBL_MONTH:12', code: '11' }
  ];

  const giornoOptions = [
    { name: 'LBL_DAY:1', code: '1' },
    { name: 'LBL_DAY:2', code: '2' },
    { name: 'LBL_DAY:3', code: '3' },
    { name: 'LBL_DAY:4', code: '4' },
    { name: 'LBL_DAY:5', code: '5' },
    { name: 'LBL_DAY:6', code: '6' },
    { name: 'LBL_DAY:7', code: '7' },
    { name: 'LBL_DAY:8', code: '8' },
    { name: 'LBL_DAY:9', code: '9' },
    { name: 'LBL_DAY:10', code: '10' },
    { name: 'LBL_DAY:11', code: '11' },
    { name: 'LBL_DAY:12', code: '12' },
    { name: 'LBL_DAY:13', code: '13' },
    { name: 'LBL_DAY:14', code: '14' },
    { name: 'LBL_DAY:15', code: '15' },
    { name: 'LBL_DAY:16', code: '16' },
    { name: 'LBL_DAY:17', code: '17' },
    { name: 'LBL_DAY:18', code: '18' },
    { name: 'LBL_DAY:19', code: '19' },
    { name: 'LBL_DAY:20', code: '20' },
    { name: 'LBL_DAY:21', code: '21' },
    { name: 'LBL_DAY:22', code: '22' },
    { name: 'LBL_DAY:23', code: '23' },
    { name: 'LBL_DAY:24', code: '24' },
    { name: 'LBL_DAY:25', code: '25' },
    { name: 'LBL_DAY:26', code: '26' },
    { name: 'LBL_DAY:27', code: '27' },
    { name: 'LBL_DAY:28', code: '28' },
    { name: 'LBL_DAY:29', code: '29' },
    { name: 'LBL_DAY:30', code: '30' },
    { name: 'LBL_DAY:31', code: '31' }
  ];

  const wdOptions = [
    { name: 'LBL_WD:1', code: '2' },
    { name: 'LBL_WD:2', code: '3' },
    { name: 'LBL_WD:3', code: '4' },
    { name: 'LBL_WD:4', code: '5' },
    { name: 'LBL_WD:5', code: '6' },
    { name: 'LBL_WD:6', code: '7' },
    { name: 'LBL_WD:7', code: '1' }
  ];

  useEffect(() => {
    loadEventi()

    if(props.tematica != null){
      var ret = []
      PJAxios().post('/chatbot/loadRoot', { idConfig: props.tematica.id_config }).then((res) => {
  
        let tematiche = res.data.items.filter((item) => item.tematica != null);
        if(tematiche != null){
          tematiche.forEach((tematica) => {
            ret.push({
              id_config: tematica.tematica,
              titolo: tematica.bundle
            })
          })
        }
  
      });
      setTematicheCollegate(ret);
    }
    

  }, [props.tematica]);


  const tematicheTemplate = (row) =>{
    return (getText(row.titolo))
  }
  
  const loadEventi = () => {
    if (props.tematica != null) {
      PJAxios().post('/gestioneConfigurazioni/listaEventi', { idConfig: props.tematica.id_config }).then((res) => {
        setEventi(res.data);
      });
    }
  }

  useEffect(() => {

    if (editEvento != null) {
      setTipoEvento(editEvento.xtipoEvento);
      setDataInizio(new Date(new Date().setTime(editEvento.data_inizio)));
      setDataInfo(new Date(new Date().setTime(editEvento.data_info)));
      setDataFine(new Date(new Date().setTime(editEvento.data_fine)));
      setMese(editEvento.mese);
      setGiorno(editEvento.giorno);
      setWd(editEvento.wd);
      setBundleEvento(editEvento.bundle_messaggio);
      setModificaEventoVisible(true)
      setPeriodicita(editEvento.periodicita)
    }
  }, [editEvento]);


  useEffect(() => {
  if(bundleEvento != null){
      setBundleEn(getTextByLang("en",bundleEvento))
      setBundleIt(getTextByLang("it",bundleEvento))
    }
  }, [bundleEvento]);


  useEffect(() => {
    if (dataInfo == null) {
      setDataInfo(dataInizio)
    }
  }, [dataInizio]);

  useEffect(() => {

    let items = []

    if (correlati != null) {
      tematicheCollegate.forEach((tematica) => {
        correlati.forEach((correlato) => {
          if (correlato.id_config == tematica.id_config) {
            items.push(tematica);
          }
        })
      })

      setSelectedTematicheCollegate(items);
    }

  }, [correlati]);

  const handleChangeTipoEvento = event => {
    /*
    var tempTipoEvento = event.target.value;

    if (tempTipoEvento === null || tempTipoEvento === "") {
      tempTipoEvento = 'n';
    }

    setTipoEvento(tempTipoEvento);*/
    setTipoEvento(event.target.value);
  }


  const hideCreateEvento = (event) => {
    setCreateEventoVisible(false);
    setModificaEventoVisible(false);
  }

  const handleChangeDataInizio = event => {
    setDataInizio(event.target.value);
  };

  const handleChangeDataInfo = event => {
    setDataInfo(event.target.value);
  };

  const handleChangeDataFine = event => {
    setDataFine(event.target.value);
  };

  const valorizzaIdConfigTemp = (rowdata) => {
    setIdConfigTemp(rowdata.id_config);
  };

  const valorizzaIdEventTemp = (rowdata) => {
    setIdEventTemp(rowdata.id_event);
  };

  const modificaBundle = (rowData) => {
    PJAxios().get('/gestioneConfigurazioni/editBundle/' + props.tematica.id_config + "/" + rowData.id_event).then((res) => {
      window.location.href = res.data;
    })
  }

  const modificaEvento = (rowData) => {
    PJAxios().post('/gestioneConfigurazioni/editEvento', { idConfig: props.tematica.id_config, idEvento: rowData.id_event }).then((res) => {
      //console.log("periodicita: ");
      //console.log(res.data.editEvento);
      if (res.data.editEvento.periodicita != null && res.data.editEvento.periodicita == "S") {
        res.data.editEvento.xtipoEvento = "S";
      }
      setCorrelati(res.data.correlati);
      setEditEvento(res.data.editEvento);
      flushCache(dbTest);
    });
  }

  const cancellazioneEvento = (rowData) => {
    //rowTemp.idConfigRowTemp = rowData.id_config;
    //rowTemp.idEventRowTemp = rowData.id_event;
    valorizzaIdConfigTemp(rowData);
    valorizzaIdEventTemp(rowData);
    setRemoveEvento();

    PJAxios().post('/gestioneConfigurazioni/removeEvento', { idConfig: props.tematica.id_config, idEvento: rowData.id_event }).then((res) => {
      setEventi(res.data);
      flushCache(dbTest);
    });

    //setEditEvento(null);
    //setCreateEvento(null);
    //setEditEventoList(null);
    //setCreateEventoList(null);
    //setEventi(null);
    setFunzioneHTML("remove");
  }

  function unaSettimanaDopo() {
    const resultDate = new Date(dataInizio);
    resultDate.setDate(resultDate.getDate() + 7);
    return resultDate;
  }

  const nuovoEvento = () => {

    setCreateEventoVisible(true)

    PJAxios().post('/gestioneConfigurazioni/createEvento', { idConfig: props.tematica.id_config }).then((res) => {
      setCreateEvento(res.data.createEvento);
      flushCache(dbTest);
    });



    setFunzioneHTML("add");

    if (createEvento != null) {
      setTipoEvento(null);
      setDataInizio(null);
      setDataFine(null);
      setMese(null);
      setGiorno(null);
      setWd(null);
    }
  }

  const salvataggioEvento = () => {
    
    PJAxios().post('/gestioneConfigurazioni/editEventoTransaction', {
      idEvento: editEvento != null ? editEvento.id_event : null,
      salvaEventoRequest: {
        idConfig: props.tematica.id_config,
        idEvento: idEventTempEdit,
        bundleEn: bundleEn.htmlValue ? bundleEn.htmlValue : bundleEn,
        bundleIt: bundleIt.htmlValue ? bundleIt.htmlValue : bundleIt,
        evento: {
          id_config: idConfigTempEdit,
          id_event: idEventTempEdit,
          xtipoEvento: tipoEvento,
          data_info: dataInfo == null ? dataInizio : dataInfo,
          data_inizio: dataInizio,
          data_fine: dataFine,
          mese: mese,
          giorno: giorno,
          wd: wd,
          periodicita: tipoEvento == 'n' ? null : tipoEvento
        }
      },
      tematicheCollegate: selectedTematicheCollegate
    }).then((res) => {
      //console.log(res)
      if(res.data == true){
        loadEventi()
        flushCache(dbTest);
        setCreateEventoVisible(false)
        setModificaEventoVisible(false)
      }
      
      props.onEditEventoTransactionCompleted(res.data)

    });
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button label={getText("MODIFICA")} className='p-button-secondary' icon="pi pi-pencil" onClick={() => { modificaEvento(rowData) }}></Button>
        <Button label={getText("CANCELLA")} className='p-button-danger' icon="pi pi-trash" onClick={() => { cancellazioneEvento(rowData) }}></Button>
        {/*<PJLinkSalto id_servizio="673" returnURL="/gestioneConfigurazioni" al_id_srv_chiamante="2479" params={{c_app:30511,codice_bundle:""}} label="Modifica Bundle" >salto</PJLinkSalto>
        <Button size="small" className="p-button p-button-primary" onClick={() => { modificaBundle(rowData) }}>Modifica Bundle</Button>*/}
      </React.Fragment>
    );
  }

  const actionRemoveEventoBodyTemplate = (rowData) => {
    return (
      <React.Fragment>

      </React.Fragment>
    );
  }

  const dateBodyTemplate = (rowData) => {

    var d = new Date(rowData.data_inizio)

    return (
      <React.Fragment>
        <Calendar disabled value={d} showTime hourFormat="24" dateFormat="dd/mm/yy" />
      </React.Fragment>
    );
  }

  const dateInfoBodyTemplate = (rowData) => {


    if (rowData.data_info != null) {
      var d = new Date(rowData.data_info)
      return (
        <React.Fragment>
          <Calendar disabled value={d} showTime hourFormat="24" dateFormat="dd/mm/yy" />
        </React.Fragment>
      );
    } else {
      return (<></>)
    }

  }

  const dateEndBodyTemplate = (rowData) => {

    var d = new Date(rowData.data_fine)

    return (
      <React.Fragment>
        <Calendar disabled value={d} showTime hourFormat="24" dateFormat="dd/mm/yy" />
      </React.Fragment>
    );
  }

  const rowClass = (data) => {
    return {
      "centered": data.gruppoVisibilita === 'HELPDESK'
    }
  }

  const selectedTipoEventoTemplate = (option) => {
    if (option) {
      return (
        <div>{getText(option.name)}</div>
      );
    }
  }

  const selectedMeseTemplate = (option) => {
    if (option) {
      return (
        <div>{getText(option.name)}</div>
      );
    }
  }

  const meseOptionTemplate = (option) => {
    return (
      <div>{getText(option.name)}</div>
    );
  }

  const selectedGiornoTemplate = (option) => {
    if (option) {
      return (
        <div>{getText(option.name)}</div>
      );
    }
  }

  const giornoOptionTemplate = (option) => {
    return (
      <div>{getText(option.name)}</div>
    );
  }

  const selectedWdTemplate = (option) => {
    if (option) {
      return (
        <div>{getText(option.name)}</div>
      );
    }
  }

  const wdOptionTemplate = (option) => {
    return (
      <div>{getText(option.name)}</div>
    );
  }


  function getGiorniSettimanaInRange(data_inizio, data_fine) {
    const startDate = new Date(data_inizio);
    const endDate = new Date(data_fine);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(24, 0, 0, 0);


    if (startDate > endDate) {
      [data_inizio, data_fine] = [data_fine, data_inizio];
    }

    const daysOfWeek = new Set();


    let currentDate = new Date(data_inizio);
    while (currentDate <= endDate) {
      daysOfWeek.add(currentDate.getDay());
      currentDate.setDate(currentDate.getDate() + 1);
    }


    const orderedDays = Array.from(daysOfWeek).sort((a, b) => b - a);

    return orderedDays;
  }

  function isDataInizio(giorno, dataInizio) {
    return giorno == moment(dataInizio).format('dddd').substring(0, 3);
  }

  function isDataFine(giorno, dataFine) {
    return giorno == moment(dataFine).format('dddd').substring(0, 3);
  }

  const settimanaSelectionedTemplate = (evento) => {
    const giorniSettimana = [];
    const orario = [];
    
    for (let i = 0; i < 7; i++) {
      let giorno=[null,null, null];
      if(isDataInizio(moment().day(i).format('dddd').substring(0, 3), evento.data_inizio) && isDataFine(moment().day(i).format('dddd').substring(0, 3), evento.data_fine))
        giorno=[moment(evento.data_inizio).format('HH:mm'),moment(evento.data_fine).format('HH:mm'),moment().day(i).format('dddd').substring(0, 3)];
      else if (isDataInizio(moment().day(i).format('dddd').substring(0, 3), evento.data_inizio))
        giorno=[moment(evento.data_inizio).format('HH:mm'),null,moment().day(i).format('dddd').substring(0, 3)];
      else if (isDataFine(moment().day(i).format('dddd').substring(0, 3), evento.data_fine))
        giorno=[null,moment(evento.data_fine).format('HH:mm'), moment().day(i).format('dddd').substring(0, 3)];
      else
        giorno=[null,null, moment().day(i).format('dddd').substring(0, 3)];

      giorniSettimana.push(giorno);
    }

    return (
      <div className="settimana-container">
        {giorniSettimana.map((giorno, index) => (
          <div
            key={index}
            className={`giorno pj-bg-white-special ${getGiorniSettimanaInRange(evento.data_inizio, evento.data_fine).includes(index) ? 'pj-bg-primary-special' : ''} ${giorno[0]!=null ? 'inizio ' : ''}${giorno[1]!=null ? 'fine' : ''}`}>
            <div className={`gapOrarioEventi`}>{giorno[0]}</div>
            {giorno[2]}
            <div className='gapOrarioEventi'>{giorno[1]}</div>

          </div>
        ))}
      </div>
    );
  };


  const itemEventTemplate = (evento) => {
    return (
      <div className='containerEvento'>
        <div className='evento-id'>{evento.id_event}</div>
        <div className='evento-dates'>{settimanaSelectionedTemplate(evento)}</div>
        <div className="evento-actions">
          {actionBodyTemplate(evento)}
        </div>
      </div>

    );
  };

  useEffect(() => {
    if (eventi == null)
      setFilteredEvents(eventi);
    else {
      if ("n" == tipoEvento)
        setFilteredEvents(eventi.filter(evento => evento.periodicita ===null||evento.periodicita==="n"));
      else setFilteredEvents(eventi.filter(evento => evento.periodicita && evento.periodicita === tipoEvento));
    }
  }, [tipoEvento, eventi]);


  

  return (

    <div className='Home'>
      <div className="formgrid grid">
        <div className="col-12">

          <span style={{ textAlign: "left", textTransform: "uppercase" }}><h6><b>{getText("NASCONDI_TEMATICA")}</b></h6></span>
          <br />
          <span style={{ textAlign: "left" }}>{getText("ELENCO_EVENTI_SUBTITLE")}</span>
          <table>
            <tbody>
            <tr>
              <td className="cellaTabella">
                <div>
                  <label htmlFor="tipoEventoObj">{getText("TIPO_EVENTO")} </label>

                </div>
              </td>
              <td className="cellaTabella">
                <Dropdown className="divCombo" id="tipoEventoObj" optionLabel="name" optionValue="code" value={tipoEvento} options={tipoEventoOptions} valueTemplate={selectedTipoEventoTemplate} itemTemplate={selectedTipoEventoTemplate} onChange={handleChangeTipoEvento} />
              </td>
            </tr>
            </tbody>
          </table>
          {tipoEvento == "n" &&
            <DataTable paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} emptyMessage={getText("TEMATICA_SEMPRE_VISIBILE")} rowClassName={rowClass} showGridlines size="small" title={getText("ELENCO_EVENTI_DISPONIBILI")} stripedRows value={filteredEvents == null ? eventi : filteredEvents}>
              <Column className="centeredColumn" field="id_event" header={getText("ID_EVENTO")}></Column>
              <Column header={getText("DATA_INFO")} body={dateInfoBodyTemplate}></Column>
              <Column header={getText("DATA_INIZIO")} body={dateBodyTemplate}></Column>
              <Column header={getText("DATA_FINE")} body={dateEndBodyTemplate}></Column>
              <Column body={actionBodyTemplate} header={getText("AZIONI")} exportable={false}></Column>
            </DataTable>
          }
          {tipoEvento == "S" &&
            <div className='border'>
              <div className='headerUguale'>
                <div className='divLeft'>
                  <p className='labelTabella'>{getText("ID_EVENTO")}</p>
                </div>
                <div className='divCenter'>
                  <h3 className='labelTabella'>{getText("SETTIMANA")}</h3>
                </div>
                <div className='divRight'>
                  <h3 className='labelTabella'>{getText("AZIONI")}</h3>
                </div>
              </div>
              <DataView layout="list" paginator rows={5} itemTemplate={itemEventTemplate} rowsPerPageOptions={[5, 10, 25, 50]} emptyMessage={getText("TEMATICA_SEMPRE_VISIBILE")} title={getText("ELENCO_EVENTI_DISPONIBILI")} value={filteredEvents == null ? eventi : filteredEvents}>
              </DataView>
            </div>
          }
        </div>
      </div>
      <br />
      <p style={{ textAlign: "left" }}><Button icon="pi pi-plus" onClick={() => nuovoEvento()} label={getText("NUOVO_EVENTO")} /></p>
      <div>&nbsp;</div>

      <Dialog visible={createEventoVisible || modificaEventoVisible} style={{ width: '90%' }} header={getText("NASCONDI_TEMATICA")} modal onHide={hideCreateEvento}>
        <div className="confirmation-content">
          <div>
            <table >
              <tr>
                <td className="cellaTabella">
                  <div>
                    <label htmlFor="tipoEventoObj">{getText("TIPO_EVENTO")} </label>

                  </div>
                </td>
                <td className="cellaTabella">
                  <Dropdown className="divCombo" id="tipoEventoObj" optionLabel="name" optionValue="code" value={tipoEvento} options={tipoEventoOptions} valueTemplate={selectedTipoEventoTemplate} itemTemplate={selectedTipoEventoTemplate} onChange={handleChangeTipoEvento} />
                </td>
              </tr>
              {tipoEvento == 'n' &&
                <>
                  <tr>
                    <td className="cellaTabella">
                      <div>
                        <label htmlFor="dataInizioObj">{getText("DATA_INFO")} </label>

                      </div>
                    </td>
                    <td className="cellaTabella">
                      <Calendar id="dataInfoObj" showTime hourFormat="24" dateFormat="dd/mm/yy" value={dataInfo} showIcon onChange={handleChangeDataInfo}></Calendar>
                    </td>
                  </tr>
                  <tr>
                    <td className="cellaTabella">
                      <div>
                        <label htmlFor="dataInizioObj">{getText("DATA_INIZIO")} </label>

                      </div>
                    </td>
                    <td className="cellaTabella">
                      <Calendar id="dataInizioObj" showTime hourFormat="24" dateFormat="dd/mm/yy" value={dataInizio} showIcon onChange={handleChangeDataInizio}></Calendar>
                    </td>
                  </tr>
                  <tr>
                    <td className="cellaTabella">
                      <div>
                        <label htmlFor="dataFineObj">{getText("DATA_FINE")}</label>

                      </div>
                    </td>
                    <td className="cellaTabella">
                      <Calendar id="dataFineObj" showTime hourFormat="24" dateFormat="dd/mm/yy" value={dataFine} showIcon onChange={handleChangeDataFine}></Calendar>
                    </td>
                  </tr>
                  <tr>
                    <td className="cellaTabella">
                      <div>
                        <label htmlFor="tipoEventoObj">{getText("BUNDLES")} </label>
                      </div>
                    </td>
                    <td className="cellaTabella">
                      <div className="p-fluid grid">

                        <div className="col-6 md:col-6">
                          {getText("BUNDLE_IT")}
                          <Editor style={{
                                height: '320px',
                                border: '1px solid #ced4da',
                                borderRadius: '6px',
                                overflow: 'hidden',
                                backgroundColor: '#f8f9fa' // Colore dietro la toolbar
                            }}
                                // Stile specifico per l'area dove si scrive
                                contentStyle={{
                                    height: '250px',
                                    backgroundColor: '#ffffff',
                                    color: '#495057',
                                    borderTop: '1px solid #ced4da' // Separa la toolbar dal testo
                                }} length="100"  value={bundleIt} onTextChange={(e) => setBundleIt(e)} placeholder={getText("INSERISCI_BUNDLE_IT_PLACEHOLDER")} />
                        </div>
                        <div className="col-6 md:col-6">
                          {getText("BUNDLE_EN")}
                          <Editor length="100" style={{
                                height: '320px',
                                border: '1px solid #ced4da',
                                borderRadius: '6px',
                                overflow: 'hidden',
                                backgroundColor: '#f8f9fa' // Colore dietro la toolbar
                            }}
                                // Stile specifico per l'area dove si scrive
                                contentStyle={{
                                    height: '250px',
                                    backgroundColor: '#ffffff',
                                    color: '#495057',
                                    borderTop: '1px solid #ced4da' // Separa la toolbar dal testo
                                }} value={bundleEn} onTextChange={(e) => setBundleEn(e)} placeholder={getText("INSERISCI_BUNDLE_EN_PLACEHOLDER")} />
                        </div>
                      </div>
                    </td>
                  </tr>
                </>


              }
              {tipoEvento == "S" &&
                <>
                  <tr>
                    <td className="cellaTabella">
                      <div>
                        <label htmlFor="dataInizioObj">{getText("DATA_INFO")} </label>

                      </div>
                    </td>
                    <td className="cellaTabella">
                      <Calendar id="dataInfoObj" showTime hourFormat="24" dateFormat="dd/mm/yy" value={dataInfo} showIcon onChange={handleChangeDataInfo}></Calendar>
                    </td>
                  </tr>
                  <tr>
                    <td className="cellaTabella">
                      <div>
                        <label htmlFor="dataInizioObj">{getText("DATA_INIZIO")} </label>

                      </div>
                    </td>
                    <td className="cellaTabella">
                      <Calendar id="dataInizioObj" showTime hourFormat="24" dateFormat="dd/mm/yy" value={dataInizio} showIcon onChange={handleChangeDataInizio}></Calendar>
                    </td>
                  </tr>
                  <tr>
                    <td className="cellaTabella">
                      <div>
                        <label htmlFor="dataFineObj">{getText("DATA_FINE")}</label>

                      </div>
                    </td>
                    <td className="cellaTabella">
                      <Calendar id="dataFineObj" showTime hourFormat="24" dateFormat="dd/mm/yy" minDate={dataInizio} maxDate={dataInizio != null ? unaSettimanaDopo() : dataInizio} value={dataFine} showIcon onChange={handleChangeDataFine}></Calendar>
                    </td>
                  </tr>

                  <tr>
                    <td className="cellaTabella">
                      <div>
                        <label htmlFor="tipoEventoObj">{getText("BUNDLES")} </label>
                      </div>
                    </td>
                    <td className="cellaTabella">
                      <div className="p-fluid grid">

                        <div className="col-6 md:col-6">
                          {getText("BUNDLE_IT")}
                          <Editor length="100" style={{
                                height: '320px',
                                border: '1px solid #ced4da',
                                borderRadius: '6px',
                                overflow: 'hidden',
                                backgroundColor: '#f8f9fa' // Colore dietro la toolbar
                            }}
                                // Stile specifico per l'area dove si scrive
                                contentStyle={{
                                    height: '250px',
                                    backgroundColor: '#ffffff',
                                    color: '#495057',
                                    borderTop: '1px solid #ced4da' // Separa la toolbar dal testo
                                }}  value={getTextByLang("it",bundleEvento)} onTextChange={(e) => setBundleIt(e)} placeholder={getText("INSERISCI_BUNDLE_IT_PLACEHOLDER")} />
                        </div>
                        <div className="col-6 md:col-6">
                          {getText("BUNDLE_EN")}
                          <Editor length="100" style={{
                                height: '320px',
                                border: '1px solid #ced4da',
                                borderRadius: '6px',
                                overflow: 'hidden',
                                backgroundColor: '#f8f9fa' // Colore dietro la toolbar
                            }}
                                // Stile specifico per l'area dove si scrive
                                contentStyle={{
                                    height: '250px',
                                    backgroundColor: '#ffffff',
                                    color: '#495057',
                                    borderTop: '1px solid #ced4da' // Separa la toolbar dal testo
                                }} value={getTextByLang("en",bundleEvento)} onTextChange={(e) => setBundleEn(e)} placeholder={getText("INSERISCI_BUNDLE_EN_PLACEHOLDER")} />
                        </div>
                      </div>
                    </td>
                  </tr>
                </>


              }
              {tipoEvento == "y" &&
                <>
                  <tr>
                    <td className="cellaTabella">
                      <div>
                        <label htmlFor="meseObj">{getText("MESE")} </label>

                      </div>
                    </td>
                    <td className="cellaTabella">
                      <Dropdown className="divCombo" id="meseObj" optionLabel="name" optionValue="code" value={mese} options={meseOptions} valueTemplate={selectedMeseTemplate} itemTemplate={meseOptionTemplate} onChange={(e) => setMese(e.value)} />
                    </td>

                  </tr>
                  <tr>
                    <td className="cellaTabella">
                      <div>
                        <label htmlFor="giornoObj">{getText("DAY_OF_MONTH")} </label>

                      </div>
                    </td>
                    <td className="cellaTabella">
                      <Dropdown className="divCombo" id="giornoObj" optionLabel="name" optionValue="code" value={giorno} options={giornoOptions} valueTemplate={selectedGiornoTemplate} itemTemplate={giornoOptionTemplate} onChange={(e) => setGiorno(e.value)} />
                    </td>
                  </tr>
                  <tr>
                    <td className="cellaTabella">
                      <div>
                        <label htmlFor="wdObj">{getText("DAY_OF_MONTH")} </label>

                      </div>
                    </td>
                    <td className="cellaTabella">
                      <Dropdown className="divCombo" id="wdObj" optionLabel="name" optionValue="code" value={wd} options={wdOptions} valueTemplate={selectedWdTemplate} itemTemplate={wdOptionTemplate} onChange={(e) => setWd(e.value)} />
                    </td>
                  </tr>
                </>
              }

              {(props.tematica.id_config == 48 || props.tematica.id_config == 114) &&

                <tr>


                  <td className="cellaTabella">
                    <label htmlFor="wdObj">{getText("TEMATICHE_COLLEGATE")} </label>
                  </td>
                  <td className="cellaTabella">
                    <>
                      <DataTable value={tematicheCollegate} selectionMode={'checkbox'} selection={selectedTematicheCollegate} onSelectionChange={(e) => setSelectedTematicheCollegate(e.value)}
                        dataKey="id_config" tableStyle={{ minWidth: '50rem' }}>
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                        <Column field="id_config" header="id"></Column>
                        <Column body={tematicheTemplate} field="titolo" header="titolo"></Column>
                      </DataTable>


                    </>
                  </td>
                </tr>

              }

              <tr>
                <td className="cellaTabellaCenter">
                  <div>
                    {createEventoVisible && <Button onClick={() => salvataggioEvento()}>{getText("AGGIUNGI_EVENTO")}</Button>}
                    {modificaEventoVisible && <Button onClick={() => salvataggioEvento()}>{getText("MODIFICA_EVENTO")}</Button>}
                  </div>
                </td>
              </tr>

            </table>
          </div>

        </div>
      </Dialog>


    </div>


  )
}

export default GestioneEventi
